/* istanbul ignore file */
/* tslint:disable */

/* eslint-disable */


export namespace TaxSystemIntegrationImportRequest {
    export enum TaxSystemIntegrationImportAgendas {
        PREACCOUNTINGS = "PREACCOUNTINGS",
        DOCUMENT_TYPES = "DOCUMENT_TYPES",
        ACTIVITIES = "ACTIVITIES",
        CENTRES = "CENTRES",
        CONTRACTS = "CONTRACTS",
    }
}

import TaxSystemIntegrationImportAgendas = TaxSystemIntegrationImportRequest.TaxSystemIntegrationImportAgendas;

export type TaxSystemIntegrationImportRequest = {
    agendas?: Array<TaxSystemIntegrationImportAgendas>;
};
